import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../shared/services/api.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UserModel } from '../core/models/user.model';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class LoginService extends ApiService {
    userSubject = new BehaviorSubject<UserModel | null>(null);
    constructor(protected override http: HttpClient, protected override toastr: ToastrService, private router: Router) {
        super('/Auth', http, toastr);
    }

    logout(): void {
        this.userSubject.next(null);
        localStorage.removeItem('user');
        this.router.navigate(['/Login']);
    }

    public login(data: any): Observable<any> {
        return this.post(data, 'Login');
    }

    autoLogin(): void {
        const user = localStorage.getItem('user');
        if (user) {
            const userJson = JSON.parse(user);
            const authUser = new UserModel();
            authUser.email = userJson.email;
            authUser.id = userJson.id;
            authUser.name = userJson.name;
            authUser.token = userJson.token;
            this.userSubject.next(authUser);
            if (!window.location.href.includes('admin')) {
                this.router.navigate(['/']);
            }
        }
    }
}
